import React from 'react';
import { Card } from '@app/components/common/Card/Card';
import MailerSetting from '@app/components/setting/MailerSetting';
import GeneralSetting from '@app/components/setting/GeneralSetting';

const SettingPage: React.FC = () => {
  return (
    <>
      <Card padding="1rem 3rem" title="Mailer Settings" style={{ height: 'auto', margin: '36px' }}>
        <MailerSetting />
      </Card>
      <Card padding="1rem 3rem" title="General Settings" style={{ height: 'auto', margin: '36px' }}>
        <GeneralSetting />
      </Card>
    </>
  );
};

export default SettingPage;
